export default "__VITE_ASSET__$1w7Da9Y__"